import { FlowStepMetadataMap, StepAccordionSpec } from "common/components/AccordionFlow/AccordionFlowTypes";

export const getAccordionMetadataMap = (steps: StepAccordionSpec[]): FlowStepMetadataMap =>
  steps.reduce((prevMetadata, { id }, index) => ({ ...prevMetadata, [id]: { index, isValid: false } }), {});
